import { TableHeading, TableOptions } from "components/Table";
import { useRoleManagementContext } from "context";
import { getUserType, isMasterAdmin } from "helpers";
import { t } from "i18next";
import { twMerge } from "tailwind-merge";

export const RoleTableHeadings = () => {
  const { onSort } = useRoleManagementContext();
  const userType = getUserType();

  const headings: Array<JSX.Element | string> = [
    <TableHeading onClick={(order) => onSort("role-name", order)}>{t("roleManagement.roleName")}</TableHeading>,
    t("roleManagement.assignedPermissionsOrNumberOfPermissions"),
    userType && isMasterAdmin(userType?.id)
      ? t("roleManagement.numberOfUsersAssignedOrCompany")
      : t("roleManagement.numberOfUsersAssigned"),
    t("common.status"),
    <TableOptions>{t("roleManagement.options")}</TableOptions>,
  ];
  return (
    <>
      {headings.map((heading, index) => {
        const isLast = index === headings.length - 1;

        return (
          <th
            key={index}
            scope="col"
            className={twMerge(
              "h-[100px] max-h-[100px] w-[200px] min-w-[200px] break-words bg-white py-4 text-sm font-semibold text-primary",
              isLast && "shadow-left sticky right-0 z-10"
            )}
          >
            {heading}
          </th>
        );
      })}
    </>
  );
};
